<template>
  <div class="rodape-seguranca">
    <img :src="iconCadeado" class="rodape-seguranca__icone" width="14" height="14" alt="">
    <p v-if="isInterTheme" class="rodape-seguranca__texto">Seguro e criptografado.</p>
    <p v-else class="rodape-seguranca__texto">
      Seguro e criptografado. Parceiros: Itaú, Mercado Livre, Inter, Santander, Carrefour e mais
    </p>
  </div>
</template>

<script setup lang="ts">
import iconCadeado from '@/assets/images/icons/footer-shield-check.svg';
import theme from '@/services/ThemeService';

const isInterTheme = theme.isInterTheme();
</script>

<style scoped lang="scss">
@use "@/assets/styles/functions.scss" as *;
@use "@/assets/styles/vars" as *;

.rodape-seguranca {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $space-xxxxs;
  padding: $space-xxs;
  background: var(--neutral-FF, #fff);
  border-top: 1px solid var(--acerto-colors-neutral-200, #e5e8eb);
  text-align: center;
}

.rodape-seguranca__icone {
  flex-shrink: 0;
  opacity: 0.6;
}

.rodape-seguranca__texto {
  margin: 0;
  font-size: px2rem(12px);
  color: var(--neutral-77, #777);
}
</style>
